import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgTradeFill = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.25 3.75H3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5m-1.5 12.75a.75.75 0 1 1 0 1.5H5.25a.75.75 0 0 1-.75-.75V6.75a.75.75 0 0 1 1.5 0v5.899l3.27-2.726a.75.75 0 0 1 .896-.047l4.031 2.69 4.07-3.393a.75.75 0 1 1 .96 1.154l-4.5 3.75a.75.75 0 0 1-.896.047L9.8 11.434 6 14.603V16.5z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTradeFill);
export default ForwardRef;
